<template>
  <div class="w-full h-[300px] text-white overflow-hidden flex flex-col gap-3">
    <div class="px-10 py-3 flex flex-col gap-3" :class="{'bg-slate-950/20 py-4 xl:py-3': expanded !== 'emblemas'}">
      <div class="flex flex-row items-center">
        <button class="grow flex flex-row items-center" v-if="expanded !== 'emblemas'"
                @click="() => {expanded = 'emblemas'; getEmblemas()}">
          <span class="font-poppins font-bold text-sm xl:text-lg grow text-left truncate">Emblemas recentes</span>
          <i class="fa-solid fa-up-right-and-down-left-from-center"></i>
        </button>
        <span v-else class="font-poppins font-bold text-sm xl:text-lg grow truncate">Emblemas recentes</span>
        <div v-if="expanded === 'emblemas'">
          <div class="actions flex flex-row gap-2 text-xs">
            <RouterLink :to="{path: '/api', query: { tipo: 'badge'}}"
                        class="rounded-full h-7 w-7 pt-1.5 bg-slate-950/20 text-center disabled:bg-slate-950/10">
              <i class="fa-solid fa-plus"></i>
            </RouterLink>
            <button :disabled="emblemas.paginaAnteriorDesabilitada" @click="getEmblemas(emblemas.paginaAnterior)"
                    class="rounded-full h-7 w-7 bg-slate-950/20 text-center disabled:bg-slate-950/10">
              <i class="fa-solid fa-angle-left"></i>
            </button>
            <button :disabled="emblemas.proximaPaginaDesabilitada" @click="getEmblemas(emblemas.proximaPagina)"
                    class="rounded-full h-7 w-7 bg-slate-950/20 text-center disabled:bg-slate-950/15">
              <i class="fa-solid fa-angle-right"></i>
            </button>
          </div>
        </div>
      </div>
      <div v-if="expanded === 'emblemas'" class="grid grid-cols-3 grid-rows-2 gap-3">
        <template v-if="loadingEmblemas">
          <Sk v-for="i in 6" :key="i" w="100%" h="80px" rounded="rounded-md" extra="bg-white/20" />
        </template>
        <template v-else>
          <RouterLink
            v-for="(emblema, index) in emblemas.lista" :key="index"
            :to="{path: '/api', query: { tipo: 'badge', s: emblema.code}}"
            class="bg-slate-950/10 rounded-md relative overflow-hidden  min-h-[80px] w-full h-[80px]  max-h-[80px]">
            <div class="mob bg-slate-950/10 flex flex-col items-center justify-center h-[50px]">
              <img v-if="emblema.image_url || emblema.code" :src="badgeImageUrl(emblema)" />
            </div>
            <div class="flex flex-row justify-center px-2 py-1.5 relative" v-if="emblema?.code">
              <div class="valor flex flex-row items-center text-center gap-1">
                <span class="font-semibold text-xs">{{ emblema?.code }}</span>
              </div>
            </div>
          </RouterLink>
        </template>
      </div>
    </div>
    <div class="px-10 flex flex-col gap-3" :class="{'bg-slate-950/20 py-4 xl:py-3': expanded !== 'mobis'}">
      <div class="flex flex-row items-center">
        <button class="w-full flex flex-row items-center" v-if="expanded !== 'mobis'"
                @click="() => {expanded = 'mobis'; getMobis()}">
          <span class="font-poppins font-bold text-sm xl:text-lg grow text-left truncate">Mobis recentes</span>
          <i class="fa-solid fa-up-right-and-down-left-from-center"></i>
        </button>
        <span v-else class="font-poppins font-bold text-sm xl:text-lg grow truncate">Mobis recentes</span>
        <div v-if="expanded === 'mobis'">
          <div class="actions flex flex-row gap-2 text-xs">
            <RouterLink :to="{path: '/api', query: { tipo: 'mobi'}}"
                        class="rounded-full h-7 w-7 pt-1.5 bg-slate-950/20 text-center disabled:bg-slate-950/10">
              <i class="fa-solid fa-plus"></i>
            </RouterLink>
            <button :disabled="mobis.paginaAnteriorDesabilitada" @click="getMobis(mobis.paginaAnterior)"
                    class="rounded-full h-7 w-7 bg-slate-950/20 text-center disabled:bg-slate-950/10">
              <i class="fa-solid fa-angle-left"></i>
            </button>
            <button :disabled="mobis.proximaPaginaDesabilitada" @click="getMobis(mobis.proximaPagina)"
                    class="rounded-full h-7 w-7 bg-slate-950/20 text-center disabled:bg-slate-950/15">
              <i class="fa-solid fa-angle-right"></i>
            </button>
          </div>
        </div>
      </div>
      <div v-if="expanded === 'mobis'" class="grid grid-cols-3 grid-rows-2 gap-3">
        <template v-if="loadingMobis">
          <Sk v-for="i in 6" :key="i" w="100%" h="80px" rounded="rounded-md" extra="bg-white/20" />
        </template>
        <template v-else>
          <RouterLink
            v-for="(mobi, index) in mobis.lista" :key="index"
            :to="{path: '/api', query: { tipo: 'mobi', s: mobi?.classname}}"
            v-tooltip="mobi?.classname"
            :triggers="['hover']"
            class="relative bg-slate-950/10 rounded-md overflow-hidden  min-h-[80px] w-full h-[80px]  max-h-[80px]">
            <div class="mob bg-slate-950/10 flex flex-col items-center justify-center h-[50px]">
              <img :src="mobIconUrl(mobi)" />
            </div>
            <div class="flex flex-row justify-center px-2 py-1.5 relative" v-if="mobi?.classname">
              <div class="valor flex flex-row items-center text-center gap-1">
                <span class="font-semibold text-xs">{{ mobi?.classname }}</span>
              </div>
            </div>
          </RouterLink>
        </template>
      </div>
    </div>
  </div>
</template>

<script setup>

import { reactive, ref } from 'vue'
import { vTooltip } from 'floating-vue'
import { getHabbletBadges, getHabbletMobs, badgeImageUrl, mobIconUrl } from '@/services/api.js'
import Sk from '@/components/usefulness/Sk.vue'

const expanded = ref('emblemas')
const loadingEmblemas = ref(true)
const loadingMobis = ref(true)
const emblemas = reactive({
  lista: [],
  proximaPagina: 0,
  proximaPaginaDesabilitada: true,
  paginaAnterior: 0,
  paginaAnteriorDesabilitada: true
})

const mobis = reactive({
  lista: [],
  proximaPagina: 0,
  proximaPaginaDesabilitada: true,
  paginaAnterior: 0,
  paginaAnteriorDesabilitada: true
})

async function getEmblemas(pagina = 1) {
  loadingEmblemas.value = true
  const response = await getHabbletBadges({ page: pagina, limit: 6 })
  const p = response.pagination ?? {}

  // adapta para o formato que o template espera: { code, image_url }
  emblemas.lista = (response.data ?? []).map(b => ({ code: b.code, image_url: b.image_url }))
  emblemas.paginaAnterior = p.prev ?? 0
  emblemas.proximaPagina  = p.next ?? 0
  emblemas.paginaAnteriorDesabilitada = p.prev === 0
  emblemas.proximaPaginaDesabilitada  = p.next === 0
  loadingEmblemas.value = false
}

async function getMobis(pagina = 1) {
  loadingMobis.value = true
  const response = await getHabbletMobs({ page: pagina, limit: 6 })
  const p = response.pagination ?? {}

  mobis.lista = (response.data ?? []).map(m => ({ classname: m.classname ?? m.code, image_url: m.image_url }))
  mobis.paginaAnterior = p.prev ?? 0
  mobis.proximaPagina  = p.next ?? 0
  mobis.paginaAnteriorDesabilitada = p.prev === 0
  mobis.proximaPaginaDesabilitada  = p.next === 0
  loadingMobis.value = false
}

getEmblemas()
getMobis()

</script>

<style scoped>
.up {
  background-color: #4CAF50;
}

.stable {
  background-color: #4c6daf;
}

.down {
  background-color: #f44336;
}

</style>
